const RouterConfig = Object.freeze({
    home: {
        route: "/",
        name: "Trang chủ",
        pathName: "/",
    },
    policy: {
        route: "/policy",
        name: "Chính sách của Map4D",
        pathName: "/policy",
        private: {
            route: "/policy/private",
            name: "Chính sách bảo mật của Map4D",
        },
        useContent: {
            route: "/policy/useContent",
            name: "Chính sách về nội dung người dùng tạo trên Map4D",
        }
    },
    rules: {
        route: "/rules",
        name: "Điều khoản dịch vụ của Map4D",
        pathName: "/policy",
        introduce: {
            route: "/rules/introduce" ,
            name: "Giới Thiệu",
        },
        explainWords: {
            route: "/rules/explainWords",
            name: "Giải thích từ ngữ",
        },
        generalTerms: {
            route: "/rules/generalTerms",
            name: "Điểu khoản chung",

        },
        detailedTerms: {
            route: "/rules/detailedTerms",
            name: "Điều khoản chi tiết sử dụng Dịch vụ APIs Map4D",
        }
    }
});

export { RouterConfig }
